// extracted by mini-css-extract-plugin
export default {"buttonIcon":"eXRy1sj1SbEgBxqe5hOJ"};